// extracted by mini-css-extract-plugin
export var blogImageStyling = "ContentCardComponent-module--blogImageStyling--06441";
export var contentCard = "ContentCardComponent-module--contentCard--a6316";
export var contentCardFooter = "ContentCardComponent-module--contentCardFooter--229c0";
export var contentStyling = "ContentCardComponent-module--contentStyling--d099f";
export var divider = "ContentCardComponent-module--divider--6d371";
export var doctorsContent = "ContentCardComponent-module--doctorsContent--e4b9e";
export var doctorsImg = "ContentCardComponent-module--doctorsImg--b3789";
export var heightAuto = "ContentCardComponent-module--heightAuto--2821b";
export var imageStyling = "ContentCardComponent-module--imageStyling--1ac86";
export var priceStyling = "ContentCardComponent-module--priceStyling--4577d";
export var setHeight = "ContentCardComponent-module--setHeight--17d2c";
export var stepContentContainer = "ContentCardComponent-module--stepContentContainer--67d16";
export var stepsOpened = "ContentCardComponent-module--stepsOpened--9c1f9";
export var titleStyling = "ContentCardComponent-module--titleStyling--2ab8a";
export var toReadMoreContainer = "ContentCardComponent-module--toReadMoreContainer--8afdd";
export var withCtaFooter = "ContentCardComponent-module--withCtaFooter--bcaab";